var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L3.15 4.3625C3.10343 4.32757 3.06563 4.28228 3.03959 4.2302C3.01355 4.17813 3 4.12072 3 4.0625V2.375C3 2.27554 3.03951 2.18016 3.10984 2.10984C3.18016 2.03951 3.27554 2 3.375 2H8.625C8.72446 2 8.81984 2.03951 8.89017 2.10984C8.96049 2.18016 9 2.27554 9 2.375V4.04568C9 4.10366 8.98656 4.16085 8.96073 4.21275C8.93489 4.26466 8.89738 4.30987 8.85113 4.34483L6 6.5Z",
    stroke: "#96999C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L3.15 8.6375C3.10343 8.67243 3.06563 8.71772 3.03959 8.76979C3.01355 8.82187 3 8.87928 3 8.9375V10.625C3 10.7245 3.03951 10.8198 3.10984 10.8902C3.18016 10.9605 3.27554 11 3.375 11H8.625C8.72446 11 8.81984 10.9605 8.89017 10.8902C8.96049 10.8198 9 10.7245 9 10.625V8.95432C9 8.89634 8.98656 8.83915 8.96073 8.78725C8.93489 8.73534 8.89738 8.69013 8.85113 8.65517L6 6.5Z",
    stroke: "#96999C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49951 4.625H8.48056",
    stroke: "#96999C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.37479V6.5",
    stroke: "#96999C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassMedium);
export default __webpack_public_path__ + "static/media/HourglassMedium.40a666a513c68a2d7de5b5ad7d2acab0.svg";
export { ForwardRef as ReactComponent };